var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_vm._v(" Авторизация... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }